export default __webpack_public_path__ + "static/media/reply-to-threads-illustration.30bbf21d.png";